import { Map, List, fromJS } from 'immutable';

/**
 * Geography Reducer
 */
import {
    GEOGRAPHY_COUNTRIES_FETCH_REQUEST, GEOGRAPHY_COUNTRIES_FETCH_SUCCESS, GEOGRAPHY_COUNTRIES_FETCH_ERROR,
    GEOGRAPHY_PROVINCES_FETCH_REQUEST, GEOGRAPHY_PROVINCES_FETCH_SUCCESS, GEOGRAPHY_PROVINCES_FETCH_ERROR,
    GEOGRAPHY_TOWNS_FETCH_REQUEST, GEOGRAPHY_TOWNS_FETCH_SUCCESS, GEOGRAPHY_TOWNS_FETCH_ERROR
} from '../actions/geography';

const geography = (state = Map({
    countries: List([]),
    provinces: List([]),
    towns: List([]),
    isFetching: false,
    error: false
}), action) => {
    let newState;
    switch (action.type) {

        // Requests
        case GEOGRAPHY_COUNTRIES_FETCH_REQUEST:
        case GEOGRAPHY_PROVINCES_FETCH_REQUEST:
        case GEOGRAPHY_TOWNS_FETCH_REQUEST:
            newState = state.merge({
                    isFetching: action.isFetching,
                    error: action.error
                });
            return newState;

        // Success
        case GEOGRAPHY_COUNTRIES_FETCH_SUCCESS:
            newState = state.merge({
                isFetching: action.isFetching,
                error: action.error,
                countries: fromJS(action.payload)
            });
            return newState;
        case GEOGRAPHY_PROVINCES_FETCH_SUCCESS:
            newState = state.merge({
                isFetching: action.isFetching,
                error: action.error,
                provinces: fromJS(action.payload)
            });
            return newState;
        case GEOGRAPHY_TOWNS_FETCH_SUCCESS:
            newState = state.merge({
                isFetching: action.isFetching,
                error: action.error,
                towns: fromJS(action.payload)
            });
            return newState;

        // Errors
        case GEOGRAPHY_COUNTRIES_FETCH_ERROR:
        case GEOGRAPHY_PROVINCES_FETCH_ERROR:
        case GEOGRAPHY_TOWNS_FETCH_ERROR:
            newState = state.merge({
                isFetching: action.isFetching,
                error: action.error,
                errorMessage: action.errorMessage
            });
            return newState;
        default:
            return state;
    }
};

export default geography;


// WEBPACK FOOTER //
// ./src/reducers/geography.js